import { coreOnboardingProgressGetAsyncSlice } from './get';
import { coreOnboardingProgressUpdateSyncSlice } from './update';

export const {
	requestGetCoreOnboardingProgress,
	resetGetCoreOnboardingProgress
} = coreOnboardingProgressGetAsyncSlice.asyncActionCreators;

export const updateOnboardingProgress = coreOnboardingProgressUpdateSyncSlice.syncActionCreator;
